<template>
  <!-- 首页 -->
  <div id="home" class="home">
    <Header></Header>
    <div>
      <div id="navigation" class="navigation">
      <Navigate></Navigate>
      </div>
    </div>
    <div class="swiper_content">
      <div class="home_contentA">
        <!-- PC端轮播 -->
        <el-carousel height="407px" :interval="4000" class="webSwiper">
          <el-carousel-item v-for="(item, index) in lunbo" :key="index">
            <a>
              <img :src="item.TitlePhoto" />
              <li class="banners-text">
                <p v-html="item.Title"></p>
              </li>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="home_xinwen">
        <div class="flRseniority_just">
          <span>协会要闻</span>
          <span @click="toMenu('Notifiannou/Notifiannoulist')">更多 >></span>
        </div>
        <ul>
          <li
            v-for="(item, index) in xiehuiyanwen"
            :key="index"
            @mouseenter="onMouseOverA(index)"
          >
            <i class="rig_bto_icon"></i>
            <span style="font-size: 16px">
              <router-link
                :to="{
                  name: 'Notifiannoudetail',
                  query: { id: item.ContentID },
                }"
                v-html="item.Title"
              >
                <!-- {{item.title}} -->
              </router-link>
            </span>
            <br />
          </li>
        </ul>
      </div>
    </div>
    <div class="home_contentB">

      <ul v-if="false">
        <li
          v-for="(item, index) in linkUrl1"
          :key="index"
          @click="tolinkurk1(item.SiteUrl)"
        >
          <!--  -->
          <img :src="item.LogoUrl" alt="" />
        </li>
        <!-- <li
          v-for="(item,index) in yydcList"
          :key="index"
          @click="tomenuLinkurl(item.Linkurl,item)"
        >
          <img
            :src="item.TitlePhoto"
            alt=""
          >
        </li> -->
      </ul>
    </div>
    <!-- 协会动态模块 -->
    <div class="content-xiehui">
      <div class="xiehui-dongtai">
        <div class="flRseniority_just">
          <span>要闻动态</span>
          <span @click="toMenu('/Assocdynamic/NewsCenter')">更多 >></span>
        </div>
        <div class="img-show" style="">
          <router-link
            :to="{
              name: 'NewsCenterdetail',
              query: {
                id: thrsearch[0].ContentID,
              },
            }"
          >
            <img
              :src="thrsearch[0].TitlePhoto"
              alt=""
              v-if="thrsearch[0].TitlePhoto != LmurL"
            />
          </router-link>
          <!-- <img
            src="../../../static/banImage/defaulpic1.jpg"
            alt=""
            v-if="thrsearch[0].TitlePhoto != LmurL"
          > -->
        </div>
        <div class="flRseniority_justs">
          <p>
            <router-link
              :to="{
                name: 'NewsCenterdetail',
                query: {
                  id: thrsearch[0].ContentID,
                },
              }"
              v-html="thrsearch[0].Title"
            ></router-link>
          </p>
        </div>
        <div class="img-show">
          <router-link
            :to="{
              name: 'NewsCenterdetail',
              query: {
                id: thrsearch[0].ContentID,
              },
            }"
          >
            <p v-if="thrsearch[0].Abstruct != ''">
              {{ thrsearch[0].Abstruct }}
            </p>
          </router-link>
          <!-- <p v-else>李东东耿长有许正明刘建国艾立民等出席大会开幕式，郝振省当选为新一届理事会会长，李东东耿长有许正明刘建国艾立民等出席大会开幕式，郝振省当选为新一届理事会会长</p> -->
        </div>
      </div>
      <div class="xiehui-dangjian">
        <div class="flRseniority_just">
          <span>协会党建</span>
          <span @click="toMenu('/Memactive/Memactivelist')">更多 >></span>
        </div>
        <div class="img-show">
          <router-link
            v-if="dangjian[0]"
            :to="{
              name: 'Memactivedetail',
              query: {
                id: dangjian[0].ContentID,
              },
            }"
          >
            <img
              :src="dangjian[0].TitlePhoto"
              alt=""
              v-if="dangjian[0].TitlePhoto != LmurL"
            />
          </router-link>
        </div>
        <div class="flRseniority_justs">
          <p>
            <router-link
              v-if="dangjian[0]"
              :to="{
                name: 'Memactivedetail',
                query: {
                  id: dangjian[0].ContentID,
                },
              }"
              v-html="dangjian[0].Title"
            ></router-link>
          </p>
        </div>
        <div class="img-show">
          <router-link
            v-if="dangjian[0]"
            :to="{
              name: 'Memactivedetail',
              query: {
                id: dangjian[0].ContentID,
              },
            }"
          >
            <p v-if="dangjian[0].Abstruct != ''">
              {{ dangjian[0].Abstruct }}
            </p>
          </router-link>
        </div>
      </div>
      <!-- 协会概况 -->
      <div class="xiehui-jieshao">
        <div class="flRseniority_just">
          <span>协会概况</span>
        </div>
        <div class="jieshao-text"  v-if="general">
          <router-link
            :to="{
              name: 'Assocprodetail',
              query: {
                id: 162686,
              },
            }"
          >
            <p v-if="general[0].Abstruct != ''">
              {{ general[0].Abstruct }}
            </p>
          </router-link>
        </div>
        <div class="jeishao-qian">
          <ul>
            <li class="letf" @click="push('/Assocwindow/Assocpro')">
              协会简介
            </li>

            <li class="right" @click="push('/Assocwindow/Instframe')">
              组织机构
            </li>
            <li class="letf" @click="push('/Assocwindow/Assocarticle')">
              协会章程
            </li>
                   <li class="right" @click="push('/Assocwindow/ContactInfo')">
              专委会
            </li>
            <li class="letf" @click="push('/Assocwindow/Mandirect')">
              常务理事
            </li>
            <li class="right" @click="push('/Assocwindow/Directunit')">
              理事单位
            </li>
            <li class="letf" @click="push('/Assocwindow/Admiscrit')">
              规章制度
            </li>
            <li class="right" @click="push('/Assocwindow/Aplymember')">
              申请入会
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content-xiehui" >
      <div class="xiehui-dongtai">
        <!-- <img
          style="cursor: pointer"
          @click="toym(xhdtimg[0])"
          class="img_1"
          :src="xhdtimg[0].TitlePhoto"
          alt=""
        /> -->
        <div class="flRseniority_just">
          <span>政策法规</span>
          <span @click="toMenu('/Policy/Policych')">更多 >></span>
        </div>
        <ul>
          <li
            v-for="(item, index) in Policych"
            :key="index"
            @mouseenter="onMouseOverA(index)"
          >
            <i class="rig_bto_icon"></i>
            <span>
              <router-link
                :to="{ name: 'Policydetail', query: { id: item.ContentID } }"
                v-html="item.Title"
              ></router-link>
            </span>
            <br />
          </li>
        </ul>
      </div>

      <div class="xiehui-dangjian">
        <!-- <img
          style="cursor: pointer"
          @click="toym(xhdjimg[0])"
          class="img_1"
          :src="xhdjimg[0].TitlePhoto"
          alt=""
        /> -->
        <div class="flRseniority_just">
          <span>滋文轩</span>
          <span @click="toMenu('/Culture/Culturech')">更多 >></span>
        </div>
        <ul>
          <li
            v-for="(item, index) in Culture"
            :key="index"
            @mouseenter="onMouseOverA(index)"
          >
            <i class="rig_bto_icon"></i>
            <span>
              <router-link
                :to="{ name: 'Culturedetail', query: { id: item.ContentID } }"
                v-html="item.Title"
              ></router-link>
            </span>
            <br />
          </li>
        </ul>
      </div>
      <div class="xiehui-jieshao">
        <div class="flRseniority_just" style="margin-top: 27px">
          <span>通知公告</span>
          <span @click="toMenu('/Notice/Noticech')">更多 >></span>
        </div>
        <ul class="home_contentC_left_just_ul">
          <li v-for="(item, index) in partlearn" :key="index">
            <div class="periodiCon_cluster_Cont_img">
              <div class="periodiCon_cluster_Cont_img-t">{{ item.riqi }}</div>
              <div class="periodiCon_cluster_Cont_img-b">
                {{ item.AddDate }}
              </div>
            </div>
            <div class="periodiCon_cluster_Cont_right">
              <p style="">
                <router-link
                  :to="{
                    name: 'Noticedetail',
                    query: {
                      id: item.ContentID,
                    },
                  }"
                  v-html="item.Title"
                ></router-link>
              </p>
            </div>
          </li>
          <div style="clear: both"></div>
        </ul>
      </div>
    </div>
    <div class="tablebg" v-if="false">
      <div class="m1200">
        <div class="listTitle">
          <h2 id="a01">分支机构</h2>
        </div>
        <div v-html='branch'></div>
        <!-- <ul class="list">
          <li><a>传播学分会</a></li>
          <li><a>体育文化传播促进分会</a></li>
          <li><a>新媒体新闻专业委员会</a></li>
          <li><a>学术期刊专业委员会</a></li>
          <li><a>国际合作交流委员会</a></li>
          <li><a>数字互娱与电子竞技专业委员会</a></li>
          <li><a>媒体融合发展工作委员会</a></li>
          <li><a>大数据专业委员会</a></li>
          <li><a>健康传播专业委员会</a></li>
          <li><a>丝路国际卫视联盟委员会</a></li>
          <li><a></a></li>
          <li><a></a></li>
        </ul> -->
      </div>
    </div>
    <div class="home_contentF">
      <div class="home_contentC_left_just">
        <div class="flRseniority_just">
          <span>相关链接</span>
          <!-- <span @click="toMenu('/CooperaBase')">更多>></span> -->
        </div>
      </div>
      <div class="home_contentF_bto">
        <ul>
          <li
            v-for="(item, index) in linkUrl"
            :key="index"
            @click="tolinkurk(item.SiteUrl)"
          >
            {{ item.SiteName }} |
            <!-- <img
              :src="item.LogoUrl"
              alt=""
            > -->
          </li>
        </ul>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import router from "@/router/index";
import Swiper from "swiper";
import Header from "@/components/public/heade/index";
import Navigate from "@/components/public/navigation/index";
import Foot from "@/components/public/foot/index";
import axios from "axios";
// const Swiper = require("../../assets/js/idangerous.swiper.min.js")

export default {
  name: "home",
  data() {
    return {
      branch:'',
      activeIndex2: "1",
      lineList: [],
      CooperaBaseList: [],
      isShow: false,
      isShowB: false,
      isShowC: false,
      isShowD: false,
      isShowI: false,
      LmurL: "",
      just: 0,
      articleShow: false,
      partlearnShow: false,
      academicShow: false,
      lunbo: [
        // {
        //   TitlePhoto: "../../../static/banImage/banner22.png",
        //   title: "地方医师协会秘书长、二级机构总干事联席会议在京召开",
        // },
        // {
        //   TitlePhoto: "../../../static/banImage/banner22.png",
        //   title: "地方医师协会秘书长、二级机构总干事联席会议在京召开",
        // },
        // {
        //   TitlePhoto: "../../../static/banImage/3.png",
        //   title: "地方医师协会秘书长、二级机构总干事联席地方医师协会秘书长、二级机构总干事联席会议在京召开会议在京召开",
        // },
        // {
        //   TitlePhoto: "../../../static/banImage/3.png",
        //   title: "地方医师协会秘书长、二级机构总干事联席地方医师协会秘书长、二级机构总干事联席会议在京召开会议在京召开",
        // },
        // {
        //   TitlePhoto: "../../../static/banImage/3.png",
        //   title: "地方医师协会秘书长、二级机构总干事联席地方医师协会秘书长、二级机构总干事联席会议在京召开会议在京召开",
        // },
        // {
        //   img:'../../../static/banner01.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // },
        // {
        //   img:'../../../static/banner02.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // },
        // {
        //   img:'../../../static/banner03.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // }
      ],
      article: [
        {
          id: "1",
          title: "-地方医师协会秘书长、二级机构总干事联席会议在京召开",
          date: "2019-10-12",
          para: "2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合",
        },
        {
          id: "2",
          title: "-地方医师协会秘书长、二级机构总干事联席会议在京召开",
          date: "2019-10-12",
          para: "2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合",
        },
        {
          id: "3",
          title: "-全科医师心血管疾病防治能力提升项目",
          date: "2019-10-12",
          para: "2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合",
        },
        {
          id: "4",
          title: "-2019中国医师协会呼吸医师年会在福州盛大开幕",
          date: "2019-10-12",
          para: "2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合",
        },
        {
          id: "5",
          title: "-2019中国医师协会呼吸医师年会在福州盛大开幕",
          date: "2019-10-12",
          para: "2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合",
        },
      ],
      newDong: [],

      // 会员活动
      newDongD: [
        {
          TitlePhoto: "",
          Title: "公示：中国新闻文化促进会社会团体法人登记证书副本",
        },
        {
          TitlePhoto: "",
          Title: "公示：中国新闻文化促进会社会团体法人登记证书副本",
        },
        {
          TitlePhoto: "",
          Title: "公示：中国新闻文化促进会社会团体法人登记证书副本",
        },
      ],

      // 党建学习
      partlearn: [
        {
          Abstruct: "", //简介
          AddDate: "", //添加时间（通过编辑数据库改为出版时间）
          Author: "", //作者（手动填写）
          ChannelID: 1, //栏目ID
          Content: "", //全文（是富文本）
          ContentID: 1, //文章ID
          EditAuthor: 1, //最后编辑用户ID
          EditDate: "", //最后编辑时间
          FJName: "", //附件文件名
          FJPath: "", //附件地址（加前缀‘http://shfzyjzx.boyuancb.com/Admin’）
          HitCount: 1, //点击次数
          InAuthor: 1, //添加人ID
          InAuthorName: "", //添加人姓名（不可自定义）
          IsBold: 1, //标题字体是否加粗
          IsHot: 1, //是否热点（手动勾选）
          IsItalic: 1, //标题字体是否斜体
          JournalID: 1, //期刊ID（固定死的）
          Linkurl: "", //外链地址（此处会存带http://的完整url）
          Linkurl1: "",
          SortID: 1, //排序值（数字小的在前）
          Source: "", //来源（出版社写在这个字段）
          Tags: "", //关键字
          Title: "", //标题
          TitleColor: "", //标题字体颜色
          TitlePhoto: "", //标题图片（加前缀‘http://shfzyjzx.boyuancb.com/Admin’）
        },
      ],
      academicB: [],
      swiper: [],
      // 协会动态
      thrsearch: [],
      //
      yydcList: [],
      TitlePhoto: "",
      // Culture lecture hall
      CulturHall: "",
      // Is communication
      IsCommuni: "",
      // 相关链接
      linkUrl: [],
      // 特别推荐
      linkUrl1: [],
      //协会要闻
      xiehuiyanwen: [],
      //协会党建
      dangjian: [],
      // 协会概况
      general: [],
      //政策法规
      Policych: [],
      //新闻文化
      Culture: [],
      //banner
      Banner: "",
      //学会党建img
      xhdjimg: "",
      //学会动态的图
      xhdtimg: "",
    };
  },
  mounted() {
    this.banner();
  },

  methods: {
    getBranch(){
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3726,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 1,
        })
        .then((res) => {
          // this.xiehuiyanwen = res.data._itemList; //_itemList是上面那个结构体
          this.branch = res.data._itemList[0].Content;
          console.log(this.branch,'斤斤计较')
        });
    },
    toym(item) {
      if (item.Linkurl) {
        window.open(item.Linkurl);
      }
    },
    //协会党建图片
    getxhdjimg() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3638,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 1,
        })
        .then((res) => {
          // this.xiehuiyanwen = res.data._itemList; //_itemList是上面那个结构体
          this.xhdjimg = res.data._itemList;
        });
    },
    //学会动态下的图
    getdtai() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3637,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 1,
        })
        .then((res) => {
          // this.xiehuiyanwen = res.data._itemList; //_itemList是上面那个结构体
          this.xhdtimg = res.data._itemList;
        });
    },
    handleSelect(key, keyPath) {},
    // 中心概况
    mouseenter() {
      this.isShow = true;
    },
    // 中心概况
    mouseleave() {
      this.isShow = false;
    },
    // 研究团队
    mouseenterB() {
      this.isShowB = true;
    },
    // 研究团队
    mouseleaveB() {
      this.isShowB = false;
    },
    // 应用对策
    mouseenterC() {
      this.isShowC = true;
    },
    // 应用对策
    mouseleaveC() {
      this.isShowC = false;
    },
    // 学者成果
    mouseenterD() {
      this.isShowD = true;
    },
    // 学者成果
    mouseleaveD() {
      this.isShowD = false;
    },
    // 学术期刊
    mouseenterI() {
      this.isShowI = true;
    },
    // 学术期刊
    mouseleaveI() {
      this.isShowI = false;
    },
    // 研究团队
    getData() {
      axios
        .post("/SiteChannelAPI/GetList", {
          PChannelID: 2420,
          JournalID: 202007100001,
        })
        .then((res) => {
          this.lineList = res.data; //_itemList是上面那个结构体
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 合作基地
    getDataB() {
      axios
        .post("/SiteChannelAPI/GetList", {
          PChannelID: 2434,
          JournalID: 202007100001,
        })
        .then((res) => {
          this.CooperaBaseList = res.data; //_itemList是上面那个结构体
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toMenu(url) {
      this.$router.push({
        path: url,
      });
    },
    onMouseOverA(index) {
      this.articleShow = index;
    },
    onMouseOutA(index) {
      this.articleShow = index;
    },
    onMouseOverB(index) {
      this.partlearnShow = index;
    },
    onMouseOutB(index) {
      this.partlearnShow = index;
    },
    onMouseOverC(index) {
      this.academicShow = index;
    },
    onMouseOutC(index) {
      this.academicShow = index;
    },
    banner() {
      this.Banner = new Swiper(".swiper-container", {
        autoplay: true,
        speed: 300,
        loop: true,
        pagination: ".pagination",
        paginationClickable: true,
        progress: true,
        onProgressChange: function (swiper) {
          for (var i = 0; i < swiper.slides.length; i++) {
            var slide = swiper.slides[i];
            var progress = slide.progress;
            var translate = progress * swiper.width;
            var opacity = 1 - Math.min(Math.abs(progress), 1);
            slide.style.opacity = opacity;
            swiper.setTransform(slide, "translate3d(" + translate + "px,0,0)");
          }
        },
        onTouchStart: function (swiper) {
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.setTransition(swiper.slides[i], 0);
          }
        },
        onSetWrapperTransition: function (swiper, speed) {
          for (var i = 0; i < swiper.slides.length; i++) {
            swiper.setTransition(swiper.slides[i], speed);
          }
        },
        onSlideChangeStart: function (swiper) {
          $(".caption li").removeClass("active");
          $(".caption li").eq(swiper.activeLoopIndex).addClass("active");
        },
      });
    },

    // 轮播
    getlunbo() {
      var params = new URLSearchParams();
      params.append("ChannelID", 3631);
      params.append("JournalID", 202007100001);
      params.append("CurrentPage", 1);
      params.append("PageSize", 8);
      axios.post("/SiteContentAPI/GetPageList", params).then((res) => {
        this.lunbo = res.data._itemList;
        this.lunbo.forEach((e) => {
          e.TitlePhoto = this.LmurL + e.TitlePhoto;
        });
        // this.partlearn = res.data._itemList //_itemList是上面那个结构体
        // this.partlearn.forEach((item) => {
        //   item.AddDate = item.AddDate.substr(0,10)
        // })
      });
    },

    // 通知公告
    getData() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2858,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 6,
        })
        .then((res) => {
          this.partlearn = res.data._itemList; //_itemList是上面那个结构体
          this.partlearn.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            item.riqi = item.AddDate.substr(8, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
            item.AddDate = item.AddDate.substring(0, item.AddDate.length - 3);
            this.$set(
              item,
              "time",
              item.AddDate.substring(
                item.AddDate.length - 2,
                item.AddDate.length
              )
            );
          });
        });
    },
    // 特别推荐
    getDataA() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2860,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 8,
        })
        .then((res) => {
          this.yydcList = res.data._itemList; //_itemList是上面那个结构体
          this.yydcList.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            item.TitlePhoto = item.TitlePhoto;
            //  item.TitlePhoto = this.LmurL + item.TitlePhoto;
          });
        });
    },
    // tomenuLinkurl(url, item) {
    //   if (url) {
    //     window.open(url);
    //   } else {
    //     this.$router.push({
    //       path: "/Themactive/NonMember/NonMemberdetail",
    //       query: {
    //         id: item.ContentID,
    //       },
    //     });
    //   }
    // },
    // 专题活动
    getDataB() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2838,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 8,
        })
        .then((res) => {
          this.article = res.data._itemList; //_itemList是上面那个结构体
          this.article.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 政策法规
    getDataPolicych() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3329,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 6,
        })
        .then((res) => {
          this.Policych = res.data._itemList; //_itemList是上面那个结构体
          this.Policych.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 新闻文化
    getDataCulture() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3330,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 6,
        })
        .then((res) => {
          this.Culture = res.data._itemList; //_itemList是上面那个结构体
          this.Culture.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },

    // 协会要闻
    getDatax() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3327,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 10,
        })
        .then((res) => {
          this.xiehuiyanwen = res.data._itemList; //_itemList是上面那个结构体
          this.xiehuiyanwen.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 特别推荐
    getDatadangjian() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3328,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 6,
        })
        .then((res) => {
          this.dangjian = res.data._itemList; //_itemList是上面那个结构体
          this.dangjian.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },

    getDataR() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2854,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 3,
        })
        .then((res) => {
          this.newDong = res.data._itemList; //_itemList是上面那个结构体
          this.initSwiper();
          this.newDong.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
          });
        });
    },
    // 协会领导
    getDataC() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2833,
          JournalID: 202007100001,
          IncludeChildChannel: true,
          CurrentPage: 1,
          PageSize: 50,
        })
        .then((res) => {
          this.swiper = res.data._itemList; //_itemList是上面那个结构体
          this.swiper.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
          });
        });
    },
    // 协会概况
    getDataC() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 3632,
          JournalID: 202007100001,
          IncludeChildChannel: true,
          CurrentPage: 1,
          PageSize: 1,
        })
        .then((res) => {
          this.general = res.data._itemList; //_itemList是上面那个结构体
          this.general.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 5);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
          });
        });
    },
    // 文化讲堂
    getDataD() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2852,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 8,
        })
        .then((res) => {
          this.CulturHall = res.data._itemList; //_itemList是上面那个结构体
          this.CulturHall.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 情况交流
    getDataE() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2853,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 13,
        })
        .then((res) => {
          this.IsCommuni = res.data._itemList; //_itemList是上面那个结构体
          this.IsCommuni.forEach((item) => {
            item.AddDate = item.AddDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
            this.IsCommuni = this.IsCommuni.sort(this.compare("Linkurl"));
          });
        });
    },
    // 文章
    getDataF() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2433,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 100000,
        })
        .then((res) => {
          this.academicB = res.data._itemList; //_itemList是上面那个结构体
          this.academicB.forEach((item) => {
            item.EditDate = item.EditDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
            this.academicB = this.academicB.sort(this.compare("Linkurl"));
          });
        });
    },
    // 协会动态
    getDataDD() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2837,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 4,
        })
        .then((res) => {
          this.thrsearch = res.data._itemList;
          //_itemList是上面那个结构体
          this.thrsearch.forEach((item) => {
            item.EditDate = item.EditDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 会员活动
    getHyacti() {
      axios
        .post("/SiteContentAPI/GetPageList", {
          ChannelID: 2855,
          JournalID: 202007100001,
          CurrentPage: 1,
          PageSize: 4,
        })
        .then((res) => {
          this.newDongD = res.data._itemList; //_itemList是上面那个结构体
          this.newDongD.forEach((item) => {
            item.EditDate = item.EditDate.substr(0, 10);
            item.TitlePhoto = this.LmurL + item.TitlePhoto;
            item.AddDate = item.AddDate.substr(0, 10);
          });
        });
    },
    // 相关链接
    getLinkurl() {
      axios
        .post("/FriendlyLinkWebAPI/GetList", {
          ChannelID: 2859,
          JournalID: 202007100001,
        })
        .then((res) => {
          this.linkUrl = res.data.data; //_itemList是上面那个结构体
          this.linkUrl.forEach((item) => {
            item.LogoUrl = item.LogoUrl;
          });
        });
    },
    // 相关链接跳转
    tolinkurk(url) {
      window.open(url);
    },
    // 特别推荐
    getLinkurl1() {
      axios
        .post("/FriendlyLinkWebAPI/GetList", {
          ChannelID: 2860,
          JournalID: 202007100001,
        })
        .then((res) => {
          this.linkUrl1 = res.data.data; //_itemList是上面那个结构体
          this.linkUrl1.forEach((item) => {
            item.LogoUrl = item.LogoUrl;
          });
        });
    },
    tolinkurk1(url) {
      // window.location.href="url";
      window.open(url);
    },
    push(data) {
      this.$router.push(data);
    },
    initSwiper() {
      this.$nextTick(function () {
        var swiper = new Swiper("#swiperB", {
          direction: "vertical",
          loop: true,
          slidesPerView: 1,
          paginationClickable: true,
          spaceBetween: 30,
          centeredSlides: true,
          autoplay: 2500,
          autoplayDisableOnInteraction: false,
        });
      });
    },
    compare(attr) {
      return function (a, b) {
        var val1 = a[attr];
        var val2 = b[attr];
        return val1 - val2;
      };
    },
  },
  components: {
    Header,
    Navigate,
    Foot,
  },
  created() {
    this.getxhdjimg();

    this.getdtai();
    //  this.getData();
    // this.getDataB();
    this.getData();
    this.getDataA();
    this.getDataB();
    this.getDataC();
    this.getDataD();
    this.getDataE();
    this.getDataF();
    this.getDataR();
    this.getDataDD();
    this.getDatax();
    this.getDatadangjian();
    this.getDataPolicych();
    this.getDataCulture();
    this.getlunbo();
    // 会员活动
    this.getHyacti();
    // 相关链接
    this.getLinkurl();
    this.getLinkurl1();
    this.getBranch()
  },
  updated() {
    this.initSwiper();
    var swiper = new Swiper("#sipwewesss", {
      loop: true,
      autoplay: 2500,
      autoplayDisableOnInteraction: false,
      pagination: ".swiper-pagination",
      direction: "vertical",
      paginationClickable: true,
      spaceBetween: 30,
    });

    var swiper = new Swiper("#swiper-container", {
      pagination: ".swiper-pagination",
      paginationClickable: true,
      slidesPerView: 6,
      pagination: ".swiper-pagination",
      paginationClickable: ".swiper-pagination",
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      spaceBetween: 30,
    });
    var swiper = new Swiper("#swiperA", {
      pagination: ".swiper-pagination",
      slidesPerView: 5,
      paginationClickable: true,
      spaceBetween: 30,
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
    });
  },
};
</script>

<style lang="less" scoped>
#navigation {
  width: 100%;
  height: 60px;
  position: relative;
  top: -5px;
  .navigation_cont {
    width: 100%;
    height: auto;
  }
  .el-menu-demo {
    background: #c01b22 !important;
  }
  /deep/.el-menu {
    background: red;
    li {
      background: #c01b22 !important;
      color: #fff !important;
    }
  }
  /deep/.el-menu--popup {
    padding: 0px !important;
  }
  .ul {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    background: #c01b22;
  }
  ul {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    background: #c01b22;
    .home_nav {
      list-style: none;
      float: left;
      font-weight: bold;
      height: 60px;
      position: relative;
      width: 120px;
      // text-align: center;
      line-height: 60px;
      /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
        height: 100% !important;
        line-height: 47px !important;
      }
      /deep/.el-submenu__title:hover {
        background-color: #c01b22 !important;
      }
      .home_nav_aa {
        display: inline-block;
        color: #fff;
        font-size: 20px;
        height: 60px;
        width: 112px;
        position: relative;
        text-align: center;
        line-height: 60px;
      }
      .home_nav_a_i {
        width: 1px;
        height: 16px;
        background: #fff;
        position: r;
        position: absolute;
        top: 23px;
        left: 110px;
      }
    }
    .home_lfer {
      margin-left: 527px;
    }
    li:last-child {
      a {
        border-right: none;
      }
    }
    .router-link-active {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #ab1c22;
      // border-bottom: 1px solid #fff;
    }
    .active {
      a {
        color: #fff;
      }
    }
    li:hover {
      background-color: #ab1c22;
      // a{
      //   border-bottom: 1px solid #fff;
      // }
    }
  }
  .navigation_content {
    width: 144%;
    height: auto;
    position: absolute;
    z-index: 999;
    top: 61px;
    left: -21px;
    background: #fff;
    padding: 10px 0;
    box-shadow: 2px 2px 3px 3px #ccc;
    li {
      text-align: center;
      float: none !important;
      line-height: 36px;
      background: #fff !important;
      height: 36px;
      a {
        width: 100% !important;
        font-size: 15px !important;
        color: #333 !important;
        top: 0px !important;
        border: none !important;
      }
    }
    li:hover {
      background-color: #c01b22 !important;
      a {
        color: #fff !important;
      }
    }
  }
  .navigation_contentB {
    width: 190%;
    li {
      height: auto !important;
    }
  }
  .navigation_contentC {
    width: 140%;
    li {
      height: auto !important;
    }
  }
}
#home {
  width: 100%;
  height: auto;
  .swiper_content {
    width: 1200px;
    height: 400px;
    margin: 0 auto;
    padding-bottom: 30px;
    padding-top: 30px;
    // overflow: hidden;
    .home_contentA {
      float: left;
      width: 592px;
      height: 416px;
      margin-right: 172px;
      position: relative;
      top: -5px;
      img {
        width: 100%;
        height: 100%;
      }
      /deep/.el-carousel--horizontal {
        width: 122%;
        height: 100%;
        position: absolute;
        /deep/.el-carousel__container {
          width: 100%;
          height: 100%;
        }
      }
      /deep/.el-carousel--horizontal img {
        width: 100%;
        height: 100%;
      }
      background-size: cover;
    }
    .banners-text {
      margin-top: -56px;
      background-color: #000000;
      opacity: 0.4;
      list-style: none;
      color: #e6e6e6;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      padding-left: 30px;
      font-weight: bold;
      padding-left: 30px;
      p {
        width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        box-orient: vertical;
      }
    }
    .home_xinwen {
      float: left;
      width: 436px;
      height: 400px;
      overflow: hidden;
      .flRseniority_just {
        width: 436px;
        height: 32px;
        border-bottom: 2px solid #cccccc;
        margin-bottom: 20px;
        span:nth-child(1) {
          float: left;
          width: 108px;
          height: 32px;
          color: #c01b22;
          font-size: 20px;
          text-align: left;
          line-height: 22px;
          font-family: "SourceHanSansSC-Regular";
          font-weight: bold;
          cursor: pointer;
        }
        span:nth-child(2) {
          float: right;
          width: 320px;
          height: 32px;
          color: black;
          font-weight: 600;
          line-height: 33px;
          font-size: 15px;
          text-align: right;
          cursor: pointer;
          i {
            color: black;
            font-size: 15px;
            position: relative;
            top: 2px;
          }
        }
      }
      ul {
        width: 100%;
        height: 100%;
        li {
          list-style: none;
          padding: 4px;
          height: 36px;
          // margin-bottom: 10px;
          position: relative;
          .rig_bto_icon {
            width: 10px;
            height: 10px;
            background: #c01b22;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            top: 10px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 90%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #151515;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #151515;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
      }
    }
  }

  .home_contentAB {
    width: 1200px;
    height: 200px;
    margin: 0 auto;
    .home_contentA_right {
      width: 100%;
      height: 200px;
      .home_contentA_right_top {
        width: 580px;
        height: 200px;
        background: #f8f8f8;
        float: left;
        .home_contentA_right_title {
          width: 100%;
          height: 33px;
          position: relative;
          .dynamic {
            width: 96px;
            height: 33px;
            background: url("../../../static/banImage/标签.png") no-repeat;
            background-size: cover;
            padding-left: 8px;
            line-height: 24px;
            font-size: 14px;
            color: #fff;
          }
          .swiper_more {
            float: right;
            position: relative;
            top: -26px;
            span {
              color: #c01b22;
              font-size: 16px;
              cursor: pointer;
            }
            i {
              color: #c01b22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
          .swiper-pagination {
            width: 91px !important;
            height: 20px !important;
            position: absolute;
            top: 4px;
            left: 71%;
            /deep/.swiper-pagination-bullet {
              width: 20px !important;
              height: 20px !important;
              border: 1px solid #c01b22;
              border-radius: 0;
              margin-right: 6px;
              background: transparent;
            }
            /deep/.swiper-pagination-bullet-active {
              background: #c01b22 !important;
            }
          }
        }
        /deep/.swiper-container {
          top: 25px;
          left: 36px;
        }
        /deep/.el-carousel__container {
          position: relative;
          top: 3px;
        }
        /deep/.el-carousel__indicators {
          display: none;
          padding: 20px 4px;
        }
        /deep/.el-carousel__item {
          width: 100% !important;
          height: 100% !important;
          p:nth-child(1) {
            width: 94%;
            color: #c01b22;
            font-size: 20px;
            margin: 0 auto;
            // text-indent: 2em;
            font-weight: bold;
            margin-top: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            cursor: pointer;
          }
          p:nth-child(2) {
            width: 94%;
            color: #151515;
            font-size: 14px;
            // text-indent: 2em;
            margin: 0 auto;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-top: 3px;
            cursor: pointer;
          }
        }
      }
      .home_contentA_right_bottom {
        width: 580px;
        height: 192px;
        float: right;
        .flRseniority_just {
          width: 580px;
          height: 32px;
          span:nth-child(1) {
            float: left;
            width: 88px;
            height: 32px;
            color: #333;
            font-size: 20px;
            text-align: center;
            line-height: 22px;
            font-family: "SourceHanSansSC-Regular";
            border-bottom: 2px solid #c01b22;
            cursor: pointer;
          }
          span:nth-child(2) {
            float: right;
            width: 488px;
            height: 32px;
            color: #c01b22;
            line-height: 33px;
            font-size: 16px;
            text-align: right;
            border-bottom: 2px solid #eeeeee;
            cursor: pointer;
            i {
              color: #c01b22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
        }
        ul {
          width: 100%;
          height: 100%;
          li {
            list-style: none;
            padding: 3px;
            margin-bottom: 10px;
            position: relative;
            .rig_bto_icon {
              width: 20px;
              height: 20px;
              background: #c01b22;
              position: absolute;
              border-radius: 50%;
              float: left;
              display: inherit;
              text-align: center;
              line-height: 21px;
              color: #fff;
              font-style: normal;
            }
            span:nth-child(2) {
              width: 79%;
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              margin-left: 31px;
              a {
                color: #151515;
                font-size: 16px;
              }
            }
            span:nth-child(3) {
              float: right;
              color: #151515;
              font-size: 14px;
            }
            div {
              width: 78%;
              text-align: justify;
              color: #151515;
              font-size: 14px;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
              margin-left: 30px;
            }
          }
          li:hover {
            div {
              color: #c01b22;
            }
            span:nth-child(2) {
              a {
                color: #c01b22;
              }
            }
            span:nth-child(3) {
              color: #c01b22;
            }
          }
        }
      }
    }
  }
  .home_contentB {
    width: 1200px;
    // height: 155px;
    margin: 0 auto;
    margin-top: 60px;
    .flRseniority_just {
      width: 100%;
      height: 32px;
      border-bottom: 2px solid #cccccc;
      span:nth-child(1) {
        float: left;
        width: 108px;
        height: 32px;
        color: #c01b22;
        font-size: 20px;
        text-align: left;
        line-height: 22px;
        font-weight: bold;
        font-family: "SourceHanSansSC-Regular";
        // border-bottom: 2px solid #c01b22;
        cursor: pointer;
      }
      span:nth-child(2) {
        float: right;
        width: 238px;
        height: 32px;
        color: #151515;
        font-weight: 600;
        line-height: 33px;
        font-size: 14px;
        text-align: right;
        border-bottom: 2px solid #cccccc;
        cursor: pointer;
      }
    }
    ul {
      width: 100%;
      height: 100%;
      margin-top: 22px;
      display: flex;
      flex-wrap: wrap;

      li {
        list-style: none;
        width: 286px;
        height: 92px;
        float: left;
        margin-right: 18px;
        margin-bottom: 20px;
        position: relative;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
      li:nth-child(4) {
        margin-right: 0px;
      }
      li:nth-child(8) {
        margin-right: 0px;
      }
    }
  }
  .content-xiehui {
    width: 1200px;
    height: 540px;
    margin: 0 auto;
    // overflow: hidden;
    .xiehui-dongtai {
      float: left;
      width: 346px;
      height: 453px;
      margin-right: 30px;
      // .img-show{
      //   width: 350px;
      //   height: 225px;
      // }
      .img_1 {
        display: block;
        width: 350px;
        height: 100px;
        margin-bottom: 30px;
        margin-top: 30px;
        // width: 75%;
        // height: 86px;
        // margin-left: 30px;
      }
      .flRseniority_just {
        width: 100%;
        height: 32px;
        border-bottom: 2px solid #cccccc;
        margin-bottom: 20px;
        span:nth-child(1) {
          float: left;
          width: 108px;
          height: 32px;
          color: #c01b22;
          font-size: 20px;
          // text-align: center;
          line-height: 22px;
          font-weight: bold;
          font-family: "SourceHanSansSC-Regular";
          // border-bottom: 2px solid #c01b22;
          cursor: pointer;
        }
        span:nth-child(2) {
          float: right;
          width: 238px;
          height: 32px;
          font-weight: 600;
          color: #151515;
          line-height: 33px;
          font-size: 14px;
          text-align: right;
          // border-bottom: 2px solid #cccccc;
          cursor: pointer;
        }
      }
      ul {
        width: 100%;
        height: 50%;
        overflow: hidden;
        li {
          list-style: none;
          padding: 3px;
          // margin-bottom: 10px;
          position: relative;
          height: 32px;
          .rig_bto_icon {
            width: 10px;
            height: 10px;
            background: #c01b22;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            top: 8px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 90%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #151515;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #151515;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
      }
    }
    .xiehui-dangjian {
      float: left;
      width: 346px;
      height: 453px;
      margin-right: 40px;
      // .img-show{
      //   width: 350px;
      // height: 225px;
      // }
      .img_1 {
        display: block;
        width: 350px;
        height: 100px;
        margin-bottom: 30px;
        margin-top: 30px;
        // margin-left: 30px;
      }
      .flRseniority_just {
        width: 100%;
        height: 32px;
        margin-bottom: 20px;
        border-bottom: 2px solid #cccccc;
        span:nth-child(1) {
          float: left;
          width: 108px;
          height: 32px;
          color: #c01b22;
          font-size: 20px;
          // text-align: center;
          line-height: 22px;
          font-weight: bold;
          font-family: "SourceHanSansSC-Regular";
          // border-bottom: 2px solid #c01b22;
          cursor: pointer;
        }
        span:nth-child(2) {
          float: right;
          width: 238px;
          height: 32px;
          font-weight: 600;
          color: #151515;
          line-height: 33px;
          font-size: 14px;
          text-align: right;
          // border-bottom: 2px solid #cccccc;
          cursor: pointer;
        }
      }
      ul {
        width: 100%;
        height: 100%;
        overflow: hidden;
        li {
          list-style: none;
          padding: 3px;
          // margin-bottom: 10px;
          position: relative;
          height: 32px;
          .rig_bto_icon {
            width: 10px;
            height: 10px;
            background: #c01b22;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            top: 8px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 90%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #151515;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #151515;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
      }
    }
    .xiehui-jieshao {
      float: left;
      width: 432px;
      height: 453px;
      .flRseniority_just {
        width: 100%;
        height: 32px;
        border-bottom: 2px solid #cccccc;
        margin-bottom: 11px;
        span:nth-child(1) {
          float: left;
          width: 108px;
          height: 32px;
          color: #c01b22;
          font-size: 20px;
          // text-align: center;
          line-height: 22px;
          font-weight: bold;
          font-family: "SourceHanSansSC-Regular";
          // border-bottom: 2px solid #c01b22;
          cursor: pointer;
        }
        span:nth-child(2) {
          float: right;
          width: 238px;
          height: 32px;
          font-weight: 600;
          color: #151515;
          line-height: 33px;
          font-size: 14px;
          text-align: right;
          border-bottom: 2px solid #cccccc;
          cursor: pointer;
        }
      }
      .jeishao-qian {
        width: 100%;
        overflow: hidden;
        ul {
          .letf {
            float: left;
          }
          .right {
            float: right;
          }
          li {
            // background-image: url("../../../static/img/jieshaobg.jpg");
            list-style: none;
            margin-bottom: 1px;
            margin-top: 13px;
            width: 208px;
            height: 55px;
            line-height: 58px;
            text-align: center;
            background-color: #c01b22;
            font-size: 18px;
            color: #ffffff;
            cursor: pointer;
          }
        }
      }
      .home_contentC_left_just_ul {
        width: 100%;
        height: auto;
        margin-top: 10px;
        li {
          list-style: none;
          width: 432px;
          float: left;
          margin-bottom: 8px;
          .periodiCon_cluster_Cont_img {
            width: 60px;
            height: 51px;
            float: left;
            background-color: #c01b22;
            img {
              width: 100%;
              height: 100%;
            }
            .periodiCon_cluster_Cont_img-t {
              text-align: center;
              width: 50px;
              height: 25px;
              margin: 0 auto;
              border-bottom: 1px solid #f5f5f5;
              padding-bottom: 5px;
              font-size: 20px;
              font-weight: bold;
              color: #f5f5f5;
            }
            .periodiCon_cluster_Cont_img-b {
              text-align: center;
              width: 50px;
              height: 20px;
              margin: 0 auto;
              padding-bottom: 5px;
              font-size: 12px;
              padding-top: 5px;
              font-weight: bold;
              color: #f5f5f5;
            }
          }
          .periodiCon_cluster_Cont_right:hover {
            .periodiCon_cluster_Cont_right_p2 {
              color: #c01b22;
            }
            p:nth-child(1) {
              a {
                color: #c01b22;
              }
            }
            p:nth-child(3) {
              span:nth-child(1) {
                color: #c01b22;
              }
            }
          }
          .periodiCon_cluster_Cont_right {
            padding-top: 5px;
            width: 370px;
            float: right;
            p:nth-child(1) {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              color: #871d1d;
              font-size: 16px;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 20px;
              padding-left: 15px;
              a {
                color: #141414;
              }
            }
            .periodiCon_cluster_Cont_right_p2 {
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              line-clamp: 3;
              -webkit-box-orient: vertical;
              color: #606060;
              font-size: 14px;
              margin-top: 7px;
              text-align: justify;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
            }
            p:nth-child(3) {
              width: 100%;
              height: 16px;
              margin-top: 9px;
              span:nth-child(1) {
                color: #909090;
                font-size: 14px;
                float: left;
              }
            }
          }
        }
      }
    }
    .img-show {
      width: 350px;
      height: 260px;
      img {
        width: 345px;
        height: 259px;
      }
      p {
        //         text-align-last:justify;

        // text-align:justify;

        // text-justify:distribute-all-lines;
        // text-align: center;
        line-height: 29px;
        text-indent: 30px;
        font-size: 14px;
        color: #271f1f;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        box-orient: vertical;
      }
    }
    .jieshao-text {
      width: 100%;
      height: 194px;
      overflow: hidden;
      margin-bottom: 7px;
      p {
        //          text-align-last:justify;
        // text-align:justify;
        // text-justify:distribute-all-lines;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 29px;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        box-orient: vertical;
        font-size: 14px;
        color: #666666;
      }
    }
    .flRseniority_justs {
      width: 100%;
      // height: 32px;
      padding-top: 25px;
      padding-bottom: 9px;
      border-bottom: 2px solid #cccccc;
      margin-bottom: 10px;
      p {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        box-orient: vertical;
        font-size: 19px;
        font-weight: bold;
        a {
          color: #000000;
        }
      }
    }
  }
  .tablebg {
    width: 100%;
    background-color: #c01b22;
    padding-bottom: 50px;
    margin-top: -67px;
    // margin:  -83px 0 auto;
    .m1200 {
      width: 1200px;
      margin: auto;
      overflow: hidden;
      height: auto;
      .listTitle {
        padding: 15px 0;
        text-align: center;
        letter-spacing: 1px;
        h2 {
          font-size: 20px;
          color: #f5f5f5;
        }
      }
      .list {
        border: 1px solid #f5f5f5;
        overflow: hidden;
        border-right: none;
        border-bottom: none;
        li {
          width: 25%;
          float: left;
          list-style: none;
          a {
            display: block;
            border: 1px solid #f5f5f5;
            border-top: none;
            border-left: none;
            height: 48px;
            line-height: 48px;
            text-align: center;
            color: #fff;
            font-size: 15px;
            overflow: hidden;
          }
        }
      }
    }
  }
  .home_contentC {
    width: 1200px;
    height: 445px;
    margin: 0 auto;
    margin-top: 41px;
    .home_contentC_left {
      width: 580px;
      float: left;
      height: 414px;
      .flRseniority_just {
        width: 580px;
        height: 32px;
        span:nth-child(1) {
          float: left;
          width: 88px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: "SourceHanSansSC-Regular";
          border-bottom: 2px solid #c01b22;
          cursor: pointer;
        }
        span:nth-child(2) {
          float: right;
          width: 488px;
          height: 32px;
          color: #c01b22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #eeeeee;
          cursor: pointer;
          i {
            color: #c01b22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      ul {
        width: 100%;
        height: 100%;
        margin-top: 5px;
        .home_contentC_left_just_zsfb {
          width: 580px;
          height: 173px;
          border: 1px solid #e6e6e6;
          margin-top: 11px;
          cursor: pointer;
          .home_contentC_left_just_zsfb_img {
            width: 212px;
            height: 145px;
            float: left;
            margin-top: 14px;
            margin-left: 18px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .home_contentC_left_just_zsfb_tit {
            width: 52%;
            float: left;
            margin-left: 24px;
            margin-top: 78px;
            font-size: 16px;
            color: #151515;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            white-space: nowrap;
          }
        }
        li {
          list-style: none;
          padding: 3px;
          margin-bottom: 6px;
          .rig_bto_icon {
            width: 20px;
            height: 20px;
            background: #d3d3d3;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            line-height: 21px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 79%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #151515;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #151515;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:nth-child(2),
        li:nth-child(3),
        li:nth-child(4) {
          .rig_bto_icon {
            background: #c01b22;
          }
        }
        li:nth-child(2) {
          margin-top: 23px;
        }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
      }
    }
    .home_contentC_right {
      width: 580px;
      float: right;
      height: 414px;
      .flRseniority_just {
        width: 580px;
        height: 32px;
        span:nth-child(1) {
          float: left;
          width: 88px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: "SourceHanSansSC-Regular";
          border-bottom: 2px solid #c01b22;
          cursor: pointer;
        }
        li {
          list-style: none;
          float: right;
          width: 488px;
          height: 32px;
          color: #c01b22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #eeeeee;
          cursor: pointer;
          .just {
            background: #c01b22;
            color: #fff !important;
          }
          .home_contentC_right_just_type {
            float: left;
            width: 97px;
            height: 29px;
            color: #969696;
            font-size: 16px;
            line-height: 31px;
            text-align: center;
            margin-left: 15px;
          }
          i {
            color: #c01b22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      ul {
        width: 100%;
        height: 100%;
        margin-top: 11px;
        // li:nth-child(1),
        // li:nth-child(2){
        //   // margin-bottom: 13px;
        // }
        li:hover {
          div {
            color: #c01b22;
          }
          span:nth-child(2) {
            a {
              color: #c01b22;
            }
          }
          span:nth-child(3) {
            color: #c01b22;
          }
        }
        li {
          list-style: none;
          padding: 3px;
          margin-bottom: 6px;
          .rig_bto_icon {
            width: 20px;
            height: 20px;
            background: #d3d3d3;
            position: absolute;
            border-radius: 50%;
            float: left;
            display: inherit;
            text-align: center;
            line-height: 21px;
            color: #fff;
            font-style: normal;
          }
          span:nth-child(2) {
            width: 79%;
            float: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            margin-left: 31px;
            a {
              color: #151515;
              font-size: 16px;
            }
          }
          span:nth-child(3) {
            float: right;
            color: #151515;
            font-size: 14px;
          }
          div {
            width: 78%;
            text-align: justify;
            color: #151515;
            font-size: 14px;
            margin-top: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
            margin-left: 30px;
          }
        }
        li:nth-child(1),
        li:nth-child(2),
        li:nth-child(3) {
          .rig_bto_icon {
            background: #c01b22;
          }
        }
      }
    }
  }
  .home_contentAC {
    width: 1200px;
    height: 229px;
    margin: 0 auto;
    margin-top: 41px;
    .home_contentA_right {
      width: 100%;
      height: 222px;
      .home_contentA_right_top {
        width: 580px;
        height: 222px;
        float: left;
        .flRseniority_just {
          width: 580px;
          height: 32px;
          span:nth-child(1) {
            float: left;
            width: 88px;
            height: 32px;
            color: #333;
            font-size: 20px;
            text-align: center;
            line-height: 22px;
            font-family: "SourceHanSansSC-Regular";
            border-bottom: 2px solid #c01b22;
            cursor: pointer;
          }
          span:nth-child(2) {
            float: right;
            width: 488px;
            height: 32px;
            color: #c01b22;
            line-height: 33px;
            font-size: 16px;
            text-align: right;
            border-bottom: 2px solid #eeeeee;
            cursor: pointer;
            i {
              color: #c01b22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
        }
        .home_contentC_left_just_zsfb {
          width: 580px;
          height: 173px;
          border: 1px solid #e6e6e6;
          margin-top: 11px;
          .home_contentC_left_just_zsfb_img {
            width: 212px;
            height: 145px;
            float: left;
            margin-top: 14px;
            margin-left: 18px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .home_contentC_left_just_zsfb_tit {
            width: 52%;
            float: left;
            margin-left: 24px;
            margin-top: 78px;
            font-size: 16px;
            color: #151515;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            white-space: nowrap;
          }
        }
        /deep/.el-carousel__container {
          position: relative;
          top: 3px;
        }
        /deep/.el-carousel__indicators {
          display: none;
        }
        /deep/ .el-carousel__indicators--horizontal {
          padding: 20px 4px;
        }
        /deep/.el-carousel__item {
          width: 100% !important;
          height: 100% !important;
        }
      }
      .home_contentA_right_bottom {
        width: 580px;
        height: 192px;
        float: right;
        .flRseniority_just {
          width: 580px;
          height: 32px;
          span:nth-child(1) {
            float: left;
            width: 88px;
            height: 32px;
            color: #333;
            font-size: 20px;
            text-align: center;
            line-height: 22px;
            font-family: "SourceHanSansSC-Regular";
            border-bottom: 2px solid #c01b22;
            cursor: pointer;
          }
          span:nth-child(2) {
            float: right;
            width: 488px;
            height: 32px;
            color: #c01b22;
            line-height: 33px;
            font-size: 16px;
            text-align: right;
            border-bottom: 2px solid #eeeeee;
            cursor: pointer;
            i {
              color: #c01b22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
        }
        .home_contentC_left_just_zsfb {
          width: 580px;
          height: 173px;
          border: 1px solid #e6e6e6;
          margin-top: 11px;
          ul {
            width: 100%;
            height: 100%;
            li {
              list-style: none;
              width: 120px;
              height: 150px;
              float: left;
              margin-top: 11px;
              margin-right: 68px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            li:nth-child(1) {
              margin-left: 33px;
            }
            li:nth-child(3) {
              margin-right: 33px;
              border: 1px solid #efefef;
            }
          }
        }
        ul {
          width: 100%;
          height: 100%;
          li {
            list-style: none;
            padding: 3px;
            margin-bottom: 10px;
            position: relative;
            .rig_bto_icon {
              width: 20px;
              height: 20px;
              background: #c01b22;
              position: absolute;
              border-radius: 50%;
              float: left;
              display: inherit;
              text-align: center;
              line-height: 21px;
              color: #fff;
              font-style: normal;
            }
            span:nth-child(2) {
              width: 79%;
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              margin-left: 31px;
              a {
                color: #151515;
                font-size: 16px;
              }
            }
            span:nth-child(3) {
              float: right;
              color: #151515;
              font-size: 14px;
            }
            div {
              width: 78%;
              text-align: justify;
              color: #151515;
              font-size: 14px;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
              margin-left: 30px;
            }
          }
        }
      }
    }
  }
  .home_contentD {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-top: 40px;
    .flRseniority_just {
      width: 100%;
      height: 32px;
      span:nth-child(1) {
        float: left;
        width: 88px;
        height: 32px;
        color: #333;
        font-size: 20px;
        text-align: center;
        line-height: 22px;
        font-family: "SourceHanSansSC-Regular";
        border-bottom: 2px solid #c01b22;
        cursor: pointer;
      }
      span:nth-child(2) {
        float: right;
        width: 1108px;
        height: 32px;
        color: #c01b22;
        line-height: 33px;
        font-size: 16px;
        text-align: right;
        border-bottom: 2px solid #eeeeee;
        cursor: pointer;
        i {
          color: #c01b22;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          top: 2px;
        }
      }
    }
    /deep/.swiper-container {
      width: 100%;
      height: 293px;
      margin-top: 19px;
      /deep/.swiper-wrapper {
        width: 100%;
        /deep/.swiper-slide {
          // width: 180px!important;
          height: 100%;
          margin-right: 20px;
          position: relative;
          cursor: pointer;
          .swiper_slide_cover {
            width: 100%;
            height: 231px;
            position: absolute;
            top: 0;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
            color: #fff;
            padding-top: 125px;
            display: none;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: 200px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
            font-size: 14px;
          }
          a {
            width: 180px;
            height: 231px;
            position: absolute;
            top: 0;
            z-index: 999;
          }
          img {
            width: 180px;
            height: 231px;
          }
          p {
            font-size: 18px;
            color: #000;
            text-align: center;
            font-weight: bold;
          }
        }
        .swiper-slide:hover {
          .swiper_slide_cover {
            display: block;
          }
        }
      }
      /deep/.swiper-button-next {
        width: 70px;
        height: 231px;
        opacity: 1 !important;
        position: absolute;
        top: 22px;
        right: 0;
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        display: none;
        i {
          font-size: 45px;
          color: #fff;
          position: relative;
          top: 80px;
          left: 9px;
        }
      }
      /deep/.swiper-button-prev {
        width: 70px;
        height: 231px;
        opacity: 1 !important;
        position: absolute;
        top: 22px;
        left: 0;
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 0) 100%
        );
        display: none;
        i {
          font-size: 45px;
          color: #fff;
          position: relative;
          top: 80px;
          left: 9px;
        }
      }
    }
    .swiper-container:hover {
      .swiper-button-prev,
      .swiper-button-next {
        display: block;
      }
    }
  }
  .home_contentF {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-top: 41px;
    .flRseniority_just {
      width: 100%;
      height: 32px;
      border-bottom: 2px solid #cccccc;
      span:nth-child(1) {
        float: left;
        width: 108px;
        height: 32px;
        color: #c01b22;
        font-size: 20px;
        // text-align: center;
        line-height: 22px;
        font-weight: bold;
        font-family: "SourceHanSansSC-Regular";
        // border-bottom: 2px solid #c01b22;
        cursor: pointer;
      }
      span:nth-child(2) {
        float: right;
        width: 238px;
        height: 32px;
        color: #151515;
        font-weight: 600;
        line-height: 33px;
        font-size: 14px;
        text-align: right;
        border-bottom: 2px solid #cccccc;
        cursor: pointer;
      }
    }
    .home_contentF_bto {
      width: 100%;
      height: 90px;
      margin-top: 18px;
      overflow: hidden;
      ul {
        width: 100%;
        height: auto;
        li {
          // width: 80px;
          height: 60px;
          float: left;
          list-style: none;
          // font-weight: 600;
          font-size: 16px;
          // display: flex;
          // border: 1px solid #e5dedf;
          // margin-right: 25px;
          margin-right: 6px;
          margin-top: 20px;
          cursor: pointer;
          color: #151515;
          img {
            width: 100%;
            height: 80%;
            padding-top: 18px;
          }
        }
        li:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .home_contentG {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    margin-top: 41px;
    .flRseniority_just {
      width: 100%;
      height: 32px;
      span:nth-child(1) {
        float: left;
        width: 88px;
        height: 32px;
        color: #333;
        font-size: 20px;
        text-align: center;
        line-height: 22px;
        font-family: "SourceHanSansSC-Regular";
        border-bottom: 2px solid #c01b22;
        cursor: pointer;
      }
      span:nth-child(2) {
        float: right;
        width: 1108px;
        height: 32px;
        color: #c01b22;
        line-height: 33px;
        font-size: 16px;
        text-align: right;
        border-bottom: 2px solid #eeeeee;
        cursor: pointer;
        i {
          color: #c01b22;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          top: 2px;
        }
      }
    }
    .home_contentC_left_just_ul {
      width: 100%;
      height: auto;
      margin-top: 15px;
      li:nth-child(1),
      li:nth-child(3) {
        margin-right: 20px;
      }
      li {
        list-style: none;
        width: 579px;
        height: 118px;
        float: left;
        margin-bottom: 24px;
        .periodiCon_cluster_Cont_img {
          width: 198px;
          height: 118px;
          float: left;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .periodiCon_cluster_Cont_right:hover {
          .periodiCon_cluster_Cont_right_p2 {
            color: #c01b22;
          }
          p:nth-child(1) {
            a {
              color: #c01b22;
            }
          }
          p:nth-child(3) {
            span:nth-child(1) {
              color: #c01b22;
            }
          }
        }
        .periodiCon_cluster_Cont_right {
          width: 370px;
          float: right;
          p:nth-child(1) {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            color: #000000;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            a {
              color: #000;
            }
          }
          .periodiCon_cluster_Cont_right_p2 {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
            color: #606060;
            font-size: 14px;
            margin-top: 7px;
            text-align: justify;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            box-orient: vertical;
            // text-indent: 2em;
          }
          p:nth-child(3) {
            width: 100%;
            height: 15px;
            margin-top: 9px;
            span:nth-child(1) {
              color: #909090;
              font-size: 16px;
              float: left;
            }
          }
        }
      }
      li:nth-child(3),
      li:nth-child(4) {
        margin-bottom: 0;
      }
    }
  }
}
#academicB {
  li {
    div {
      width: 100% !important;
      clear: both;
      p:nth-child(1) {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.marquee-outer-wrapper {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
}
.marquee-inner-wrapper {
  height: 40px;
  font-size: 14px;
  color: #c01b22;
  line-height: 40px;
  margin: 0 auto;
  white-space: nowrap;
  position: relative;
}
/* 需要将两个文字内容一样的span放在最右边 */
.marquee-inner-wrapper span {
  position: absolute;
  top: 0;
  left: 100%;
  height: 100%;
}
/* 定义第一个span的animation：时长 动画名字 匀速 循环 正常播放 */
.first-marquee {
  -webkit-animation: 50s first-marquee linear infinite normal;
  animation: 50s first-marquee linear infinite normal;
  padding-right: 100%;
}
@keyframes first-marquee {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
    display: none;
  }
}
.second-marquee {
  -webkit-animation: 25s first-marquee linear 12s infinite normal;
  animation: 25s first-marquee linear 12s infinite normal;
  padding-right: 53%;
}
@keyframes second-marquee {
  0% {
    -webkit-transform: translate3d(0%, 0, 0);
    transform: translate3d(0%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-200%, 0, 0);
    transform: translate3d(-200%, 0, 0);
    display: none;
  }
}
.xinhua {
  background: #222;
  margin: 0 auto;
  width: 655px;
  height: 341px;
  background: url("../../../static/bgbanner/bg_video.png") no-repeat;
  position: relative;
}

.swiper-container {
  width: 651px;
  height: 265px;
  margin: 18px 2px 0 2px;
  float: left;
}

.pagination {
  float: left;
  margin-top: 3px;
  z-index: 20;
  bottom: 27px;
  width: 100%;
  text-align: center;
}

.swiper-pagination-switch {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-image: url("../../../static/bgbanner/icon.png") no-repeat 0px -50px;
  cursor: pointer;
}

.swiper-pagination-switch:hover,
.swiper-active-switch {
  background: url("../../../static/bgbanner/icon.png") no-repeat -25px -50px;
}

.arrow-left {
  background: url("../../../static/bgbanner/icon.png") no-repeat;
  position: absolute;
  right: 114px;
  bottom: 28px;
  width: 21px;
  height: 24px;
  z-index: 10;
}

.arrow-left:hover {
  background-position: 0 -25px;
}

.arrow-right {
  background: url("../../../static/bgbanner/icon.png") no-repeat -22px 0;
  position: absolute;
  right: 77px;
  bottom: 28px;
  width: 21px;
  height: 24px;
  z-index: 10;
}

.arrow-right:hover {
  background-position: -22px -25px;
}

.caption {
  position: absolute;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 30px;
}

.caption li {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: -36px;
  transition: all 0.2s cubic-bezier(0.33, 0, 0.2, 1);
}

.caption .active {
  bottom: 8px;
}

.caption li a {
  color: #fff;
  font-size: 16px;
  font-family: microsoft yahei;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue